export const cofaceAccessTypes = {
  REQUEST_ALLOWED: 'REQUEST_ALLOWED',
  REQUEST_NOT_ALLOWED: 'REQUEST_NOT_ALLOWED',
  NO_CONTRACT_ID: 'NO_CONTRACT_ID',
  NOT_ENOUGH_CREDITS: 'NOT_ENOUGH_CREDITS',
};
